import { subselect } from './root';
import { propertiesSelector } from './properties';

const showWelcomeScreenSelector = (layoutState) => {
  const { showWelcomeScreen } = propertiesSelector(layoutState);

  return showWelcomeScreen;
};

export const layoutShowWelcomeScreenSelector = subselect(showWelcomeScreenSelector);
